import { AuthProvider } from "@/context/Auth";
import { GlobalProvider } from "@/context/Global";
import { BackgroundProcessMonitor } from "@/components/BackgroundProcessMonitor";
// rcovery
import Main from "@/routes/Routes";
import "@uppy/core/dist/style.css";
import "@uppy/dashboard/dist/style.css";
import { BrowserRouter as Router } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import "@fontsource/inter"; // Defaults to weight 400
import "@fontsource/roboto-mono"; // Defaults to weight 400
import { ErrorBoundary } from "@/components/ErrorBoundary";

import Hotjar from "@hotjar/browser";
import { LazyLoad } from "@/components/LazyLoad";

const siteId = 5128711;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

// Create a client
const queryClient = new QueryClient();

function App(): JSX.Element {
  return (
    <ErrorBoundary fallback={<div>Error</div>} onError={() => {}}>
      <LazyLoad brand>
        <AuthProvider>
          <GlobalProvider>
            <QueryClientProvider client={queryClient}>
              <Router>
                <BackgroundProcessMonitor />
                <Main />
              </Router>
            </QueryClientProvider>
          </GlobalProvider>
        </AuthProvider>
      </LazyLoad>
    </ErrorBoundary>
  );
}

export default App;
